
import { Button } from '@material-ui/core';
import React, { useState } from 'react';
import { useCancelLoadMutation, useGetLoadStatusReasonsQuery } from '../../loadsSlice';
import NotificationProvider from '../../../../components/NotificationProvider';
import { cancelLoadStyle } from './CancelLoadStyle';
import ConfirmationPopup from '../../../../components/ConfirmationPopup';
import CustomInput from '../../../../components/CustomInput';
import DropdownFilter from 'components/DropdownFilter';
import { loadStatuses } from 'features/loads/enums';
import { loadStatusReasonOwnerObj } from '../LoadsDashboard/loadsDashboardConsts';

function CancelLoad({ load }) {
    const classes = cancelLoadStyle()

    let [cancelLoad, { isLoading, isError, isSuccess }] = useCancelLoadMutation();
    let { data: statusReasons, error: statusReasonsError, isLoading: isLoadingStatusReasons } = useGetLoadStatusReasonsQuery();
    statusReasons = statusReasons || [];

    statusReasons = statusReasons?.map(sr => {
        return {
            ...sr,
            name: `${sr.reasonText} (${loadStatusReasonOwnerObj?.[sr.owner]?.name})`
        }
    })?.sort((a, b) => a?.name?.localeCompare(b?.name));

    const [open, setOpen] = useState(false);
    const [comment, setComment] = React.useState('');
    const [reasonId, setReasonId] = React.useState();

    let statusReasonsValues = statusReasons?.filter(s => s.statusId == loadStatuses.CANCELLED);

    const onClick = async () => {
        setOpen(true);
    }

    const onConfirm = async () => {
        const result = await cancelLoad({ loadId: load?.id, comment, groupId: load?.groupId, reasonId });
        if (result?.error) {
            NotificationProvider.error(result?.error?.data?.[0] ?? 'Failed to cancel load')
        } else {
            NotificationProvider.success(result?.data?.[0] ?? `Successfully cancelled load`);
        }
        setOpen(false);
    }

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                onClick={onClick}
            >
                Cancel Load
            </Button>
            <ConfirmationPopup
                loading={isLoading}
                title={'Cancel Load'}

                open={open}
                onConfirm={onConfirm}
                onCancel={() => setOpen(false)}
            >
                Are you sure you want to cancel the load?
                <p>
                    <div className={classes.commentReminder}>{'Please specify a cancellation reason'}</div>
                    <DropdownFilter
                        title='Reason'
                        values={statusReasonsValues}
                        onSelect={val => setReasonId(val)}
                        value={reasonId}
                        showEmpty={true} />
                    <br />
                    <br />
                    <CustomInput
                        id="comments"
                        label="Comments"
                        value={comment}
                        elementType="textarea"
                        onChange={val => setComment(val)}
                    />
                </p>
            </ConfirmationPopup>
        </div>
    );
}

export default CancelLoad;